// @needs-native-review — best-effort translation
import type { ChromeTranslations } from '../types';

export const te: ChromeTranslations = {
  'nav.nextPage': 'తర్వాతి పేజీ →',
  'nav.previousPage': '← మునుపటి పేజీ',
  'nav.continueToLevel': 'స్థాయికి కొనసాగు →',
  'nav.backToMenu': 'మెనూకు తిరిగి →',
  'howto.page': '{total}లో {n}వ పేజీ',
  'options.title': 'ఎంపికలు',
  'ui.language': 'భాష',
};
